export const BASE_URL = "http://servicios.masporpieza.mx";

// export const BASE_URL = "http://127.0.0.1";
export const API_VERSION = "api";
